import { Spin } from 'components/loadings/Spinner';
import SpinnerIMG from 'assets/images/spinner.png';
import UserRow from './UserRow';
import { UserListProps } from './types';
import { EmptyStateText, LoadingOverlay, UserListContainer } from './styles';

const UserList = ({
  users,
  examOptions,
  selectedUserIds,
  userExamSelections,
  failedAssignments,
  onUserCheckboxChange,
  onExamChange,
  loading,
  searchQuery,
  canAssignMore,
}: UserListProps) => {
  if (loading) {
    return (
      <UserListContainer>
        <LoadingOverlay>
          <Spin src={SpinnerIMG} size="medium" />
        </LoadingOverlay>
      </UserListContainer>
    );
  }

  if (users.length === 0) {
    return (
      <UserListContainer>
        <EmptyStateText>
          {searchQuery ? `No users found matching "${searchQuery}"` : 'No users available'}
        </EmptyStateText>
      </UserListContainer>
    );
  }

  return (
    <UserListContainer role="list" aria-label="Users available for voucher assignment">
      {users.map((user) => (
        <UserRow
          key={user.id}
          user={user}
          examOptions={examOptions}
          isSelected={selectedUserIds.has(user.id)}
          selectedExamIds={userExamSelections[user.id] || []}
          failedExamIds={failedAssignments[user.id] || []}
          onCheckboxChange={onUserCheckboxChange}
          onExamChange={onExamChange}
          canAssignMore={canAssignMore ?? true}
        />
      ))}
    </UserListContainer>
  );
};

export default UserList;
